<template>
    <li>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <div v-if="hasChildren" class="d-flex" @click="toggleBranch()">
            <b-icon style="margin-right: .3em; margin-top: 2%;" icon="chevron-down" :rotate=" item.isOpen ? 180 : 0"></b-icon>
            <p class="mt-2">{{ item.nombre}}</p>
        </div>
        <div v-else class="d-flex align-items-center" @click="seleccionarTratamiento(item)">
            <em class="tratamiento_outline" style="width: 1.4em;"></em>
            <p class="mt-3">{{ item.nombre }}</p>
        </div>
      
        <ul v-if="hasChildren && item.isOpen" :class="{ 'nested': true, 'active': item.isOpen }">
            <TreeItem 
                :idSeleccionado="idSeleccionado"
                v-for="(child, index) in item.tratamientosHijo" 
                :item="child" 
                :key="index"
                @seleccionarTratamiento="seleccionarTratamiento" 
            />
        </ul>
    </li>
</template>

  
<script>
    export default {
        name: 'TreeItem',
        props: {
            item: Object,
            idSeleccionado: {
                type: Number,
                default: null
            },
        },
        data() {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,
            };
        },
      created() {
        this.debug = this.$localStorageService.getDebug();
      },
        computed: {
            hasChildren() {
                return this.item.tratamientosHijo && this.item.tratamientosHijo.length > 0;
            },
        },
        methods: {
            seleccionarTratamiento(item){
                this.$emit('seleccionarTratamiento', item);
                
            },

            toggleBranch() {
                this.item.isOpen = !this.item.isOpen;
            },
        },
    };
</script>
  
<style scoped>
    ul, #myUL {
        list-style-type: none;
    }
    
    #myUL {
        margin: 0;
        padding: 0;
    }

    .nested {
        display: none;
    }
    
    .active {
        display: block;
    }
</style>
  